"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAnimationShorthand = void 0;
const parseSingleAnimationShorthand_1 = require("./parseSingleAnimationShorthand");
const character_1 = require("./character");
const skip_1 = require("./skip");
const parseAnimationShorthand = function* (input) {
    let start = 0;
    while (start < input.length) {
        const result = (0, parseSingleAnimationShorthand_1.parseSingleAnimationShorthand)(input, start);
        yield result.value;
        start = result.end;
        start = (0, skip_1.skip)(input, start, character_1.isWhiteSpace);
        if (input.codePointAt(start) === character_1.Comma) {
            start = (0, skip_1.skip)(input, start + 1, character_1.isWhiteSpace);
        }
        else {
            break;
        }
    }
};
exports.parseAnimationShorthand = parseAnimationShorthand;
